<template>
  <div class="admin" v-if="!hideSidebar">
    <Sidebar></Sidebar>
    <main class="fullPage">
      <Header></Header>
      <router-view />
    </main>
  </div>
  <div class="adminNoSidebar" v-else>
    <main>
      <Header></Header>
      <router-view />
    </main>
  </div>
</template>

<script>
import Sidebar from "../components/layout/Sidebar.vue";
import Header from "../../views/EFHeader";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapActions, mapMutations } = createNamespacedHelpers(
  "admin/defaultView"
);

export default {
  components: { Sidebar, Header },
  computed: {
    ...mapGetters(["hideSidebar"]),
    isUserEmailVerified() {
      return !!this.$store.state?.userInfo?.isEmailVerified;
    }
  },
  methods: {},
  mounted() {
    // remove temporarily
    // if (!this.isUserEmailVerified && this.$route.name !== 'VerifyUser')
    //   this.$router.push({name: 'VerifyUser'});
  }
};
</script>

<style scoped>
.fullPage {
  background: #5c6567;
}
.admin {
  display: grid;
  grid-template-columns: 250px minmax(0px, 1fr);
  grid-template-rows: minmax(0px, 1fr);
  min-height: 100%;
  height: auto;
}

.adminNoSidebar {
  display: grid;
  grid-template-rows: minmax(0px, 1fr);
  height: 100%;
}

main {
  display: grid;
  grid-template-columns: minmax(0px, 1fr);
  grid-template-rows: 50px minmax(0px, 1fr);
  overflow-y: auto;
}
</style>
